import styled from "@emotion/styled";
import { KeyboardArrowDown } from "@mui/icons-material";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  accordionSummaryClasses,
  accordionDetailsClasses,
  AccordionProps,
} from "@mui/material";
import { FC, ReactNode } from "react";
interface IContentAccordionProps extends Omit<AccordionProps, "title"> {
  title: ReactNode;
  children: NonNullable<ReactNode>;
  id?: string;
}

const StyledAccordion = styled(Accordion)(({ theme }) => ({
  boxSadow: 4,
  ["&:before"]: { content: "unset" },
  ["&:nth-of-type(n)"]: { borderRadius: 12, overflow: "hidden" },

  [`.${accordionSummaryClasses.root}`]: {
    padding: `0 ${theme.spacing(6)}`,

    minHeight: "unset",
    [`&.${accordionSummaryClasses.expanded}`]: {
      minHeight: 0,
    },
    [`& .${accordionSummaryClasses.content}`]: {
      margin: `${theme.spacing(3)} 0`,
    },
  },
  [`& .${accordionDetailsClasses.root}`]: {
    padding: theme.spacing(6),
  },
}));

export const ContentAccordion: FC<IContentAccordionProps> = ({
  children,
  title,
  id,
  ...rest
}) => {
  return (
    <StyledAccordion {...rest}>
      <AccordionSummary
        expandIcon={<KeyboardArrowDown />}
        aria-controls="panel1-content"
        id={id}
      >
        {title}
      </AccordionSummary>
      <AccordionDetails>{children}</AccordionDetails>
    </StyledAccordion>
  );
};
